import { fetchAuthSession } from '@aws-amplify/auth';
import { getApiEndpoint } from '../config/aws-config.js';
import { getSupportRouteForCategory } from '../content/helpSupportCategories.js';

async function buildAuthHeaders() {
  const session = await fetchAuthSession();
  const idToken = session?.tokens?.idToken?.toString();
  if (!idToken) {
    throw new Error('You must be logged in to contact support.');
  }
  return {
    Authorization: `Bearer ${idToken}`,
    'Content-Type': 'application/json',
  };
}

function apiBase() {
  const base = import.meta.env.VITE_API_URL || getApiEndpoint();
  if (!base) {
    throw new Error('Support API is not configured.');
  }
  return base.replace(/\/$/, '');
}

/**
 * @param {{ category: string, message: string }} payload
 * @returns {Promise<{ ticketId: string, status?: string }>}
 */
export async function submitSupportTicket(payload) {
  const route = getSupportRouteForCategory(payload.category);
  if (!route) {
    throw new Error('Invalid support category.');
  }

  const path = route === 'urgent' ? '/users/support/emergency' : '/users/support/general';
  const headers = await buildAuthHeaders();
  const response = await fetch(`${apiBase()}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      category: payload.category,
      message: payload.message.trim(),
    }),
  });

  let body = {};
  try {
    body = await response.json();
  } catch {
    body = {};
  }

  if (!response.ok) {
    const message =
      typeof body.error === 'string' && body.error.trim()
        ? body.error.trim()
        : `Support request failed (${response.status}).`;
    const error = new Error(message);
    error.status = response.status;
    if (body.ticketId) {
      error.ticketId = body.ticketId;
    }
    throw error;
  }

  if (!body.ticketId) {
    throw new Error('Support response missing ticket id.');
  }

  return body;
}
